/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Header, Typography } from '@blend/enterprise-components';

const styles = StyleSheet.create({
  sectionWrapper: {
    alignItems: 'center',
    color: BrandColors.NEUTRAL_800,
    display: 'flex',
    gap: '8px',
  },
  header: {
    ...Typography.Roboto,
    letterSpacing: '0.44px',
    lineHeight: '12px',
    textTransform: 'uppercase',
    fontWeight: 500,
    fontSize: '11px',
  },
  sectionBreak: {
    backgroundColor: '#DEDEDE',
    flexGrow: 1,
    height: '1px',
    color: '#DEDEDE',
    fontSize: 0,
    border: 0,
  },
});

export const FilterDivider = ({ children: label }: { children: string }): React.ReactElement => (
  <div className={css(styles.sectionWrapper)}>
    <Header size={6} className={css(styles.header)}>
      {label}
    </Header>
    <hr className={css(styles.sectionBreak)} />
  </div>
);
